import { library } from "@fortawesome/fontawesome-svg-core";
import { faDatabase, faFileExcel } from "@fortawesome/pro-solid-svg-icons";
// Die Stimulus-Instanz der Foundation, damit der Controller in derselben Application
// landet wie die regulären Controller.
import { application } from "../../../../../app/javascript/controllers/application";
import HgmpMrmFormController from "../hgmp_mrm_form_controller";

library.add(faDatabase, faFileExcel);

application.register("hgmp-mrm-form", HgmpMrmFormController);
